import { AppError } from './app-error';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  private toastrService!: ToastrService;

  constructor(private injector: Injector) {}

  private getToastrService(): ToastrService {
    if (!this.toastrService) {
      this.toastrService = this.injector.get(ToastrService); 
    }
    return this.toastrService;
  }

  openNotifyError(message: string) {
    this.getToastrService().error(message, '', {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  handleError(error: AppError | string): void {
    let err: AppError;
    let updatedError = error.toString().replace('Error: ', '');

    if (error.toString().includes('TypeError: ')) {
      err = typeof error === 'string'
        ? JSON.parse(updatedError.replace('TypeError: ', ''))
        : updatedError;
    } else if (typeof error === 'object' && this.isJson(error.message) && error.message.includes('"errors')) {
      let parsedError = JSON.parse(error.message);
      if (typeof parsedError.errors === 'object') {
        const errorObjs = Object.keys(parsedError.errors);
        let errorMessagesList = parsedError.errors[errorObjs[0]];
        let errorMessage: string = '';
        errorMessagesList.forEach(errMsg => {
          if (typeof errMsg === 'string') {
            errorMessage += `\n Error: ${errMsg}`;
          }
        });
        err = new AppError(error.status, 'Something went wrong');
        if (errorMessage) {
          err.message = errorMessage;
        }
        this.openNotifyError(err.message || "Something went wrong!!");
      }
    } else {
      err = typeof error === 'string' && this.isJson(updatedError)
        ? JSON.parse(updatedError)
        : error.toString().includes('Error: ')
          ? updatedError
          : error;
      const message = typeof err === 'string' ? err : err.message;
      this.openNotifyError(message || "Something went wrong!!");
    }

    console.error({ err });
    console.error({ error });
  }

  isJson(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
